<template>
  <div :class="'flex-wrapper-app'">
    <Navbar />
    <main :class="'search-main'">
      <div class="container">
        <Loader v-if="isLoading" />
        <div class="content-wrapper">
          <h1 class="search-title">{{ $t('contactPage.helpWithDelivery') }}</h1>

          <div class="contact-info">
            <h4>
              <span>{{ $t('contactPage.phone') }} </span> &nbsp;
              <a v-if="countryCode === 'GR'" href="tel:2111982107">211 198 2107</a>
              <a v-if="countryCode === 'CY'" href="tel:24024047">24 024047</a>
            </h4>
            <h4>
              <span>Email: </span> &nbsp;
              <a v-if="countryCode === 'GR'" href="#" @click.prevent="openContactModal"
                >help@skroutzdelivery.gr</a
              >
              <a v-if="countryCode === 'CY'" href="#" @click.prevent="openContactModal"
                >help@skroutzlastmile.cy</a
              >
            </h4>
            <h4 class="operating-hours">
              <span>{{ $t('contactPage.workingHours') }}</span
              >&nbsp;
              <div class="hours-content">
                {{ $t('contactPage.monToFri') }}<br />
                {{ $t('contactPage.sat') }}<br />
                {{ $t('contactPage.sun') }}<br />
                <span class="disclaimer">{{ $t('contactPage.notOfficialHolidays') }}</span>
              </div>
            </h4>
          </div>
        </div>
        <div>
          <button @click="openComplaintModal">
            {{ $t('contactPage.complaintsForm') }}
          </button>
        </div>
        <!-- <Alert /> -->
        <div v-if="errorMessage !== null">
          <h1 class="review-title">
            {{ errorMessage }}
          </h1>
        </div>
        <CommunicationFormModal
          :show="isModalOpen"
          @close="isModalOpen = false"
          :submitForm="submitForm"
          :formType="formType"
        />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Navbar from '../pages-sections/Navbar.vue';
import Footer from '../pages-sections/Footer.vue';
import Loader from '../loader/Loader.vue';
import CommunicationFormModal from '../pages-sections/CommunicationFormModal.vue';
import axios from 'axios';

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer,
    Loader,
    CommunicationFormModal,
  },
  computed: {
    countryCode() {
      return process.env.VUE_APP_COUNTRY_CODE;
    },
  },
  watch: {
    $route: 'checkUrlHash',
  },
  mounted() {
    this.checkUrlHash();
  },
  data() {
    return {
      isModalOpen: false,
      isLoading: false,
      errorMessage: null,
      formType: 'complaint', // Add formType to track which form is being shown
    };
  },
  methods: {
    checkUrlHash() {
      if (window.location.hash.length > 1) {
        const trackId = window.location.hash.replace('#', '');
        this.requestTracking(trackId);
      } else {
        this.isTrackIdValid = false;
      }
    },
    openContactModal() {
      this.formType = 'contact';
      this.isModalOpen = true;
    },
    openComplaintModal() {
      this.formType = 'complaint';
      this.isModalOpen = true;
    },
    async submitForm(name, email, phone, voucher, formMessage, formType) {
      this.isLoading = true;

      // Use different endpoints based on form type
      const endpoint = `${process.env.VUE_APP_COURIER_API}/user/communicationForm`;

      const payload = {
        name: name,
        email: email,
        phone: phone,
        voucher: voucher,
        formMessage: formMessage,
        type: formType,
      };

      try {
        const response = await axios.post(endpoint, payload);
        if (response.status === 200) {
          this.errorMessage = this.$t('toastGeneric.formSuccess');
        }
        this.isLoading = false;
        return true;
      } catch (err) {
        if (err.response?.data?.message) {
          this.errorMessage = err.response.data.message;
        } else {
          this.errorMessage = this.$t('toastGeneric.formFailure');
        }
        this.isLoading = false;
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
.review-title {
  height: auto;
  min-height: 50px;
  line-height: 34px;
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 26px;
  max-width: 490px;
  width: 100%;
  letter-spacing: 0px;
  word-wrap: break-word;
}
.flex-wrapper-app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.search-main {
  flex-grow: 1;
  display: flex;
  background: url('../../assets/images/graphic-bg-search-page.svg') no-repeat;
  padding: 145px 0 156px;
}

.container {
  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 20px;
}

.content-wrapper {
  max-width: 490px;
}

.search-title {
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 16px;
}

.hours-content {
  margin-top: 8px;
}

.disclaimer {
  font-weight: bold;
  font-size: 0.9em;
}

button {
  display: block;
  margin-top: 10px;
  width: 100px; /* Makes it wider */
  // height: 30px; /* Makes it shorter */
  font-size: 10px; /* Adjust text size for better readability */
  text-align: center;
  background-color: #f58220; /* Match the existing orange color */
  color: white;
  border: none;
  border-radius: 8px; /* Rounded corners for a sleek look */
  cursor: pointer;
}

button:hover {
  background-color: #e6731f; /* Darker shade on hover */
}

// .container {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: space-between;
//   min-height: 100vh; /* Ensures full height usage */
// }

// Mobile Small (<= 480px)
@media screen and (max-width: 480px) {
  .search-main {
    padding: 40px 0 180px;
  }

  .container {
    padding: 0 16px;
  }

  .search-title {
    font-size: 18px;
  }

  .review-title {
    font-size: 18px;
    line-height: 24px;
    max-width: 100%;
  }
}

// Mobile Large (481px - 733px)
@media screen and (max-width: 733px) {
  .search-main {
    padding: 56px 0 224px;
    background-position: bottom center;
    background-size: contain;
  }

  .content-wrapper {
    min-width: 328px;
  }

  .review-title {
    max-width: 100%;
  }
}

// Tablet (734px - 960px)
@media screen and (min-width: 734px) and (max-width: 960px) {
  .search-main {
    padding: 136px 0 433px;
    background-position: bottom center;
    background-size: contain;
  }
}

// Desktop (961px - 1500px)
@media screen and (min-width: 961px) and (max-width: 1500px) {
  .search-main {
    padding: 120px 0 120px;
    background-position: 22rem 2.5rem;
  }
}

// Large Desktop (> 1500px)
@media screen and (min-width: 1501px) {
  .search-main {
    padding: 120px 0 120px;
    background-position: 72% center;
  }
}
</style>
